export default "__VITE_ASSET__BEzpeXmY__"